export default __webpack_public_path__ + "transfix-maps/icons/D2-newWave.f7dd48422596a42be8ad4c5f88bcabf3.png";